export function useSetWindowTitle(title) {
  const prefix = "Prepivot"; // todo: can be an env var or another type of const
  document.title = prefix + (title ? " - " + title : "");
}
export function useFormatDate(date) {
  if (!date) return "";
  var options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(date).toLocaleDateString("sv-SV", options); // todo: LOCALE!
}
